import { LockOnIcon } from '@vlabs/icons';
import { Tag } from '@vlabs/uikit/components/tag';
import cn from 'classnames';

import type { Status } from '@vlabs/api/artemy/model';

import st from './shared.module.sass';
import { useUserListTableViewerTranslation } from '../../i18n';

const statusClassName = {
  active: st.StatusTag_active,
  blocked: st.StatusTag_blocked,
  pending: st.StatusTag_pending,
};

interface StatusCellProps {
  isSystem?: boolean;
  status: Status;
}

function StatusCell({
  isSystem = false,
  status,
}: StatusCellProps): React.JSX.Element {
  const { t } = useUserListTableViewerTranslation();

  return (
    <Tag
      className={cn(
        st.StatusTag,
        isSystem
          ? st.StatusTag_system
          : statusClassName[status],
      )}
      icon={isSystem ? <LockOnIcon /> : undefined}
      kind="neutral"
      shape="square"
      size="medium"
      value={
        isSystem
          ? t('status.system')
          : t(`status.${status}`)
      }
    />
  );
}

export { StatusCell };
